module.exports = __webpack_public_path__ + "static/media/Eucation Program - About BREEZE.66606d54.jpg";